/* VEDHACART — Popup-only Cart Drawer (hardened) */
(function () {
  'use strict';
  if (window.__vcPopupOnlyBound) return;
  window.__vcPopupOnlyBound = true;

  const qs = (s, r = document) => r.querySelector(s);

  let drawer = null;
  let overlay = null;

  function resolveNodes() {
    // (Re)grab nodes in case snippet was added after JS loaded
    drawer  = qs('[data-cart-drawer]');
    overlay = qs('[data-cart-overlay]');
    return !!(drawer && overlay);
  }

  let lastFocus = null;

  function openDrawer() {
    if (!resolveNodes()) return; // nothing to open
    lastFocus = document.activeElement;
    drawer.hidden = false;
    overlay.hidden = false;
    requestAnimationFrame(() => {
      drawer.setAttribute('data-open', 'true');
      overlay.setAttribute('aria-hidden', 'false');
    });
    document.documentElement.style.overflow = 'hidden';
    qs('[data-cart-close]', drawer)?.focus?.();
  }

  function closeDrawer() {
    if (!resolveNodes()) return;
    drawer.removeAttribute('data-open');
    overlay.setAttribute('aria-hidden', 'true');
    const onEnd = () => {
      drawer.hidden = true;
      overlay.hidden = true;
      document.documentElement.style.overflow = '';
      lastFocus && lastFocus.focus && lastFocus.focus();
      drawer.removeEventListener('transitionend', onEnd);
    };
    drawer.addEventListener('transitionend', onEnd);
  }

  function bindHandlers() {
    // Open from any trigger
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest?.('[data-open-cart],[data-action="open-cart"]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
    }, true);

    // Close interactions (delegated so it works even if nodes are replaced)
    document.addEventListener('click', (e) => {
      if (e.target.closest?.('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
      if (e.target.matches?.('[data-cart-overlay]')) { e.preventDefault(); closeDrawer(); }
    });

    document.addEventListener('keydown', (e) => {
      const isOpen = drawer && drawer.getAttribute('data-open') === 'true';
      if (e.key === 'Escape' && isOpen) closeDrawer();
    });

    // If any startup-deals form still tries to submit, block and just open popup
    document.addEventListener('submit', (evt) => {
      const form = evt.target.closest && evt.target.closest('form.startup-addtocart');
      if (!form) return;
      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation?.();
      openDrawer();
    }, true);
  }

  // Ensure nodes exist if snippet is already present
  document.addEventListener('DOMContentLoaded', () => {
    resolveNodes();
    bindHandlers();
  });

  // As an extra safety: re-resolve once when the page fully loads
  window.addEventListener('load', resolveNodes);
})();
